/* eslint-disable semi */
/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
// AccountFetch.ts
import { ExportReadinessModel } from '../models/ExportReadinessModel'

export default class AccountFetch {
  private serviceUrl: string

  constructor() {
    this.serviceUrl = 'api/Account'
  }

  private async fetchJson(input: RequestInfo, init?: RequestInit): Promise<any> {
    const response = await fetch(input, init)
    if (response.status === 404) {
      return null;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()
  }

  public async getExportReadinessAsync(personId: string, abn: string): Promise<ExportReadinessModel> {
    const url = `${this.serviceUrl}/GetExportReadinessAsync?personId=${encodeURIComponent(personId)}&abn=${encodeURIComponent(abn)}`
    return this.fetchJson(url)
  }

  public async addOrUpdateExportReadinessAsync(model: ExportReadinessModel): Promise<ExportReadinessModel> {
    const url = `${this.serviceUrl}/AddOrUpdateExportReadinessAsync`
    const options: RequestInit = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(model),
    }
    return this.fetchJson(url, options)
  }

  public getExportReadinessText(): Promise<{ [key: string]: string }> {
    const url = `${this.serviceUrl}/GetExportReadinessText`
    return this.fetchJson(url)
  }
}
